import { createStore } from './createStore';

const initialState = {
  isCreateVoiceModalOpen: false,
  isCloneVoiceModalOpen: false,
};

/**
 * Shared UI store for voice modal visibility.
 * AudioSidebar can be rendered in multiple places; this keeps modal state in sync.
 */
export const useVoiceModalsStore = createStore('VoiceModalsStore', (set) => ({
  ...initialState,

  openCreateVoiceModal: () =>
    set({
      isCreateVoiceModalOpen: true,
      isCloneVoiceModalOpen: false,
    }),

  openCloneVoiceModal: () =>
    set({
      isCloneVoiceModalOpen: true,
      isCreateVoiceModalOpen: false,
    }),

  closeCreateVoiceModal: () => set({ isCreateVoiceModalOpen: false }),
  closeCloneVoiceModal: () => set({ isCloneVoiceModalOpen: false }),

  closeAllVoiceModals: () =>
    set({
      isCreateVoiceModalOpen: false,
      isCloneVoiceModalOpen: false,
    }),

  resetVoiceModals: () => set(() => initialState),
}));

